import useAsyncData from "../../../../hooks/use-async-data";
import billingService from "../../billings.service";
import BillingsTaxiDriverDetails from "./billings-taxi-driver-details";
import BillingsTaxiDriverDetailsParams from "./billings-taxi-driver-details-params";

const useBillingsTaxiDriverDetails = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsTaxiDriverDetails | null>(null);

  const load = async (
    params: BillingsTaxiDriverDetailsParams,
    abortSignal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await billingService.getTaxiDriverBillingsDetails(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsTaxiDriverDetails;
